<div class="flyout-session-on-widget-component">
  <div class="flyout-headline-row">
    <div class="headline-title">
      <span>{{ "campaign.widget.session-conditions" | translate | uppercase }}</span>
    </div>
    <div class="header-close-icon">
      <mat-icon class="close-icon" (click)="closeFlyout()">close</mat-icon>
    </div>
  </div>

  <div class="flyout-session-conditions-settings">
    <div class="text-section">
      <div class="icon-section">
        <mat-icon>info</mat-icon>
      </div>
      <div class="text-part">
        <span class="text">{{ "audience.session-condition-groups.flyout-lead-text1" | translate }}</span>
        <ul>
          <li>{{ "audience.session-condition-groups.flyout-lead-text2" | translate }}</li>
          <li>{{ "audience.session-condition-groups.flyout-lead-text3" | translate }}</li>
          <li>{{ "audience.session-condition-groups.flyout-lead-text4" | translate }}</li>
        </ul>
      </div>
    </div>

    <div class="condition-group-filters-section">
      <div class="condition-group-filters-container">
        @if (currentConditionGroup) {
          <div class="filter-chip-box">
            <div class="filter-chip">
              <mat-icon class="condition-icon">save</mat-icon>
              <div class="filter-text">
                <span class="filter-type">{{ "audience.settings.saved-condition" | translate }}</span>
                <span class="filter-operator">=</span>
                <span [innerHTML]="currentConditionGroup.name" class="filter-value"></span>
              </div>
              <mat-icon class="filter-icon close-icon" (click)="setConditionGroupToWidget(undefined)">cancel</mat-icon>
            </div>
            @if (sessionConditions && sessionConditions.length > 0) {
              <div class="filter-text-and">&</div>
            }
            @if (!sessionConditions || sessionConditions.length == 0) {
              <span class="filter-text-space">&nbsp;</span>
            }
          </div>
        }
        @for (conditionFilter of sessionConditions; track conditionFilter; let index = $index; let isLast = $last) {
          <div class="filter-chip-box">
            <div class="filter-chip clickable" (click)="openSessionConditionDialog(conditionFilter, index)">
              @if (!conditionFilter.conditionConfig.svgIcon) {
                <mat-icon class="condition-icon">{{ conditionFilter.conditionConfig.icon }}</mat-icon>
              }
              @if (conditionFilter.conditionConfig.svgIcon) {
                <mat-icon class="condition-icon tb-icon" [svgIcon]="conditionFilter.conditionConfig.svgIcon"></mat-icon>
              }
              <div class="filter-text">
                <span class="filter-type">{{ conditionFilter.conditionTranslations?.type }}</span>
                @if (conditionFilter.conditionTranslations?.operator) {
                  <span class="filter-operator">
                    {{ conditionFilter.conditionTranslations?.operator }}
                  </span>
                }
                @if (conditionFilter.conditionTranslations?.value) {
                  <span [innerHTML]="conditionFilter.conditionTranslations?.value" class="filter-value"></span>
                }
                @if (conditionFilter.conditionTranslations?.campaignEventOperator) {
                  <span [innerHTML]="conditionFilter.conditionTranslations?.campaignEventOperator" class="filter-value"></span>
                  <span [innerHTML]="conditionFilter.conditionTranslations?.campaignEventValue" class="filter-value"></span>
                  <span [innerHTML]="'generic.times' | translate | lowercase" class="filter-value"></span>
                }
                @if (conditionFilter.conditionConfig.isNew) {
                  <span class="new-addon">NEW</span>
                }
              </div>
              <mat-icon
                class="filter-icon close-icon"
                (click)="removeSessionCondition(conditionFilter, index, $event)"
                [matTooltip]="
                  isRemoveSessionConditionDisabled(conditionFilter) ? (removeSessionConditionDisabledTooltipTranslation(conditionFilter) | translate) : null
                "
                matTooltipPosition="below">
                cancel
              </mat-icon>
            </div>
            @if (!isLast) {
              <div class="filter-text-and">&</div>
            }
            @if (isLast) {
              <span class="filter-text-space">&nbsp;</span>
            }
          </div>
        }
        <div class="filter-chip-box add-filter">
          <div class="filter-chip clickable" [matMenuTriggerFor]="sessionConditionsMenu">
            <mat-icon class="filter-icon">add</mat-icon>
            <div class="filter-text">{{ "audience.settings.add-condition" | translate }}</div>
          </div>
        </div>
        <mat-menu #sessionConditionsMenu="matMenu" class="condition-groups-dropdown-menu">
          <div class="conditions-section-wrapper">
            @for (conditionConfigGroup of allConditionsConfigGroups; track conditionConfigGroup) {
              <div class="conditions-section">
                @if (conditionConfigGroup.conditions.length > 0) {
                  <div class="conditions-section-title">
                    <span>{{ "audience.filter-config." + conditionConfigGroup.type | translate | uppercase }}</span>
                  </div>
                }
                @for (conditionConfig of conditionConfigGroup.conditions; track conditionConfig) {
                  <div>
                    <button
                      mat-menu-item
                      (click)="addConditionToWidget(conditionConfig)"
                      [disabled]="conditionConfig.disabled"
                      [matTooltip]="conditionConfig.disabled ? ('audience.settings.double-condition' | translate) : ''"
                      matTooltipPosition="above">
                      @if (!conditionConfig.svgIcon) {
                        <mat-icon class="criteria-icon">{{ conditionConfig.icon }}</mat-icon>
                      }
                      @if (conditionConfig.svgIcon) {
                        <mat-icon class="criteria-icon tb-icon" [svgIcon]="conditionConfig.svgIcon"></mat-icon>
                      }
                      <span class="condition-name" [class.disabled]="isDisabled(conditionConfig)">{{ conditionConfig.titleKey | translate }}</span>
                      @if (conditionConfig.isNew) {
                        <span class="new-addon">NEW</span>
                      }
                      @if (isDisabled(conditionConfig)) {
                        <app-account-upgrade-tag></app-account-upgrade-tag>
                      }
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="flyout-bottom-row">
    <button class="secondary-button" mat-stroked-button (click)="closeFlyout()">
      <span class="btn-label">{{ "generic.close" | translate | uppercase }}</span>
    </button>
    <button class="primary-button" mat-stroked-button (click)="saveSessionConditions()">
      <span class="btn-label">{{ "generic.save" | translate | uppercase }}</span>
    </button>
  </div>
</div>
